/* eslint-disable react/prop-types */
import { Radio } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import { RadioGroup } from './styled';
import { getUniqueCaseManagerProposedDates } from '../../logic';
import { FRIENDLY_DATE_FORMAT } from '../../../shared/constants';

export const COLLECTION_DATE_OTHER_OPTION = 'Other';

const DateOptions = ({ caseManagerReviewedDateOptions }) =>
  caseManagerReviewedDateOptions.map((option) => (
    <Radio key={option} value={option}>
      {dayjs(option).format(FRIENDLY_DATE_FORMAT)}
    </Radio>
  ));

export const SelectProposedDateStep = ({ dateOptionSelected, garageInvites, handleDateOptionSelected }) => {
  const caseManagerReviewedDateOptions = getUniqueCaseManagerProposedDates(garageInvites);
  return (
    <div>
      <p>
        The dates shown below are the dates entered in the reschedule proposal that correspond to the garage
        invitations currently on the booking. Please pick the date chosen by the customer.
      </p>

      <RadioGroup
        value={dateOptionSelected}
        onChange={(option) => {
          handleDateOptionSelected(option.target.value);
        }}
      >
        <DateOptions caseManagerReviewedDateOptions={caseManagerReviewedDateOptions} />
        <Radio key={COLLECTION_DATE_OTHER_OPTION} value={COLLECTION_DATE_OTHER_OPTION}>
          Other
        </Radio>
      </RadioGroup>
    </div>
  );
};

export default SelectProposedDateStep;
